// import { ADDRESS_DETAILS_TABS } from 'constants/tabs';
import { FC, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { ITab } from 'types';
import { ADDRESS_DETAILS_TABS } from 'utils/constants/tabs';
import styles from './index.module.scss';

export const AddressDetailsPage: FC = () => {
	const [activeTab, setActiveTab] = useState(ADDRESS_DETAILS_TABS[0]);

	const changeTab = (newTab: ITab) => {
		setActiveTab(newTab);
	};

	return (
		<>
			<Tabs className={styles.wrapper} value={activeTab.title} indicatorColor='transparent'>
				{ADDRESS_DETAILS_TABS.map((tab: ITab) => (
					<Tab
						key={tab.title}
						label={tab.title}
						onClick={() => changeTab(tab)}
						value={tab.title}
					/>
				))}
			</Tabs>
			<Box>{activeTab.content}</Box>
		</>
	);
};
